export const cognitoConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'ap-southeast-2_L7fVs6c0F',
      userPoolClientId: '3du9q5o9bsaa32s1tfb0hs7fd4',
      region: 'ap-southeast-2',
      signUpVerificationMethod: 'code',
      loginWith: {
        email: true
      }
    }
  }
};
